import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./Styles/style.css";
import { BrowserRouter } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { ThemeProvider } from "./v2/lib/theme/theme-provider.tsx";
import { installAuthInterceptors } from "./utils/authSession";

installAuthInterceptors();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter basename="">
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </BrowserRouter>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
